/**
 * Photo limits shared with the gateway (`GW/src/config/photos.ts`).
 * The server enforces the same values; the client checks them up front so the
 * user gets a clear message before anything is uploaded.
 */

/** Photos allowed on one check-in. A 4th upload returns 409 photo_limit_reached. */
export const MAX_PHOTOS_PER_CHECK_IN = 3;

/** Photos allowed on one tasting note. */
export const MAX_PHOTOS_PER_NOTE = 1;

/** Longest alt text the server accepts (after trimming). */
export const MAX_ALT_TEXT_LENGTH = 1000;

/** Machine-readable error code the gateway returns when a check-in is full. */
export const PHOTO_LIMIT_REACHED_CODE = 'photo_limit_reached';
